import React from 'react'
import widgetRegistry from '@/elements/widgets'
import { AreaItem } from '@/types/cms/AreaItem'
import DynamicRenderer from '@/elements/DynamicRenderer'
import AppContext from '@/types/context'
import groupRegistry from '@/elements/groups'
import { isMobile } from '@/utils/app/detect'

type PartialsProps = {
  context: AppContext
  item: AreaItem
}

const Partials = ({ item, context }: PartialsProps) => {
  const constructDynamicName = (type: string, template: string, view?: string) => {
    return [type, template, view]
      .filter((str) => str !== undefined)
      .join('-')
      .toLowerCase()
  }

  const { type, template, view } = item

  const elementName = constructDynamicName(type, template, view)

  if (
    context.webview &&
    ((elementName !== 'widget-menu-tab' && elementName.startsWith('widget-menu')) ||
      item?.model?.fields?.webviewDisabled)
  ) {
    return null
  }

  if (item.model?.fields?.device === 'mobile' && context.device && !isMobile(context.device)) {
    return null
  } else if (item.model?.fields?.device === 'desktop' && context.device && isMobile(context.device)) {
    return null
  }

  return (
    <DynamicRenderer
      item={item}
      context={context}
      name={elementName}
      registry={{ ...widgetRegistry, ...groupRegistry }}
    />
  )
}

export default Partials
